import { BaseModel } from '../base-model';

export interface IAppointmentComment {
  AppointmentId?: number;
  Comment?: string;
  Id?: number;
  ObjectId?: number;
  PersonId?: number;
  PropertyReference?: string;
  PersonReference?: string;
  NegativeFeedbackPoints?: string;
  PositiveFeedbackPoints?: string;
  PriceEstimate?: number;
  IsExistPriceEstimate?: boolean;
}
export class AppointmentComment extends BaseModel<IAppointmentComment> implements IAppointmentComment {
  AppointmentId?: number;
  Comment?: string;
  Id?: number;
  ObjectId?: number;
  PersonId?: number;
  PropertyReference?: string;
  PersonReference?: string;
  NegativeFeedbackPoints?: string;
  PositiveFeedbackPoints?: string;
  PriceEstimate?: number;
  IsExistPriceEstimate?: boolean;
  constructor(comment?: string, options?: IAppointmentComment) {
    super(options);
    this.Comment = comment;
  }
}